import { z } from 'zod'
import { createPageSchema } from '@/utils/common.data.ts'
import { UserSchema } from '@/features/user/api/user.data.ts'

export const EmployeeSchema = z.object({
  companyId: z.union([z.string(), z.number()]).transform(it => String(it)),
  restrictedToSites: z
    .array(z.union([z.string(), z.number()]).transform(it => String(it)))
    .nullable(),
  contract: z
    .object({
      startDate: z.iso.date().transform(value => new Date(value)),
      endDate: z.iso
        .date()
        .nullish()
        .transform(value => (value ? new Date(value) : null))
    })
    .nullish(),
  isSuspended: z.boolean()
})

export const UserEmployeeSchema = EmployeeSchema.extend(UserSchema.shape)
export const PagedUserEmployeeSchema = createPageSchema(UserEmployeeSchema)

export type UserEmployee = z.infer<typeof UserEmployeeSchema>
export type UserEmployeePage = z.infer<typeof PagedUserEmployeeSchema>
